import { atom } from 'jotai'

const KEY = 'selectedAccountId'

const getInitialValue = (): string | null => {
  const value = sessionStorage.getItem(KEY)
  return value || null
}

export const selectedAccountIdAtom = atom<string | null>(getInitialValue())

export const selectedAccountAtom = atom(
  (get) => get(selectedAccountIdAtom),
  (_, set, newValue: string | null) => {
    set(selectedAccountIdAtom, newValue)

    if (newValue === null) {
      sessionStorage.removeItem(KEY)
    } else {
      sessionStorage.setItem(KEY, newValue)
    }
  }
)
